import { useMutation } from "react-query";
import http from "infra/http";

function useReenviarNotificacoesAssembleiaPergunta() {
  return useMutation(
    ({id, votacaoId}: {id: string; votacaoId: string}) => {
      return http.post(`/v1/votacao/${votacaoId}/pergunta/${id}/reenviar-notificacoes`);
    },
    { retry: false }
  );
}

export default useReenviarNotificacoesAssembleiaPergunta;
